import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Import Components
import Loader from "../../../components/Loader/Index.jsx";
import PaginationComponent from "../../../components/_utils/PaginationComponent/index.jsx";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";

import CommonAccountApprovalCard from "../../../components/_utils/CommonAccountApprovalCard/index.jsx";

// Import Redux

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { getOwnerAccBalance } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import {
  addNewLabelPvt,
  getAllPrivateTransactions,
  removeNewLabelPvt,
} from "../../../redux/features/privatetransactions/privatetransactions.js";
import { getOwnerAccountIFSCDetails } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import { beneCategories } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification.js";

// Import utils
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider.js";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount.js";

import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons/index.js";
import formatDateViewAll from "../../../utils/formatDateViewAll.js";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PrivateDetailPopup from "../PrivateTxnSingleApproval/PrivateDetailPopup/index.jsx";
import AuthenticationPopup from "../../../components/PrivateTransactions/AuthenticationPopup/index.jsx";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";

const PrivateTxnAuthentication = ({ typepop }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const filterRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);

  const [pageSize, setPageSize] = useState(
    GlobalConfiguration?.searchMaxLength,
  );
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration?.lengthCheckOne,
  );
  const [active, setActive] = useState("");
  const [LabelSearchText, setLabelSearchText] = useState([]);

  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [currentFileStatus, setCurrentFileStatus] = useState("pending_for_otp");

  const [currentIfscCode, setCurrentIfscCode] = useState("");
  const [txnAmountFilter, setTxnAmountFilter] = useState("");
  const [currentCategory, setCurrentCategory] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");

  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);

  const [moreDetailId, setMoreDetailId] = useState("");
  const [selectedOtpCount, setSelectedOtpCount] = useState(0);

  const [inputData, setInputData] = useState([]);

  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labelId, setLabelId] = useState("");
  const [labels, setLabels] = useState([]);
  const popupLabels = React.useMemo(() => {
    if (!Array.isArray(labels)) return [];
    return labels.filter((label) => !/[A-Z]/.test(label || ""));
  }, [labels]);
  const [phantomMarker, setPhantomMarker] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [moreDetailOpen, setMoreDetailOpen] = useState("");

  const [privateTxnData, setPrivateTxnData] = useState({
    transaction_requests: null,
    total_count: GlobalConfiguration?.lengthCheckZero,
    title: {
      records: GlobalConfiguration?.lengthCheckZero,
      total_pages: GlobalConfiguration?.lengthCheckZero,
      page_item_count: pageSize,
    },
  });

  const services = useSelector((state) => state.refreshToken.services);
  const checkService =
    services?.includes("VAccountBalance") || services?.includes("Admin");

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  const DeclinedRed =
    "https://q2pay.in/new_assets/common/approval/rejected_red.svg";
  const PendingIcons = ICONS.PENDING;

  const handleClearParams = (e) => {
    e?.stopPropagation();
    setLabelSearchText("");
    setCurrentCategory("");

    setShowSearchBar(false);
    setSearchUserTextDebounce("");
  };

  const [allPrivateTxnDataLoading, setAllPrivateTxnDataLoading] =
    useState(true);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const dropdownOptions = PaginationConfiguration?.paginationOptions;

  const convertDate = (timestampInSeconds) => {
    if (!timestampInSeconds) return "";

    const date = new Date(
      Number(timestampInSeconds) * GlobalConfiguration?.delayTime,
    );

    const day = String(date.getDate()).padStart(
      GlobalConfiguration?.lengthCheckTwo,
      "0",
    );
    const month = String(
      date.getMonth() + GlobalConfiguration?.lengthCheckOne,
    ).padStart(GlobalConfiguration?.lengthCheckTwo, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  // Initial data with status filter and total_amount filter
  const getPrivateTxnData = async () => {
    try {
      setAllPrivateTxnDataLoading(true);

      const queryParams = {
        page_no: currentPage,
        page_size: pageSize,
      };

      if (currentFileStatus?.length) {
        queryParams.status = currentFileStatus;
      } else {
        queryParams.status = currentFileStatus;
      }

      if (currentIfscCode) {
        queryParams.owner_account_ifsc_code = currentIfscCode;
      }

      if (currentCategory) {
        queryParams.category = currentCategory;
      }

      if (txnAmountFilter) {
        queryParams.amount = txnAmountFilter;
      }

      if (
        startDateFilter &&
        endDateFilter &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.from_date = convertDate(startDateFilter);
        queryParams.to_date = convertDate(endDateFilter);
      }

      if (LabelSearchText?.length !== GlobalConfiguration?.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }

      const response = await dispatch(getAllPrivateTransactions(queryParams));
      const rawData = response?.payload || {};

      setPrivateTxnData(rawData);
      setLabels(rawData?.summary?.available_labels ?? []);
    } catch (error) {
      setPrivateTxnData({});
    } finally {
      setAllPrivateTxnDataLoading(false);
    }
  };

  const onMount = () => {
    getPrivateTxnData();
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();

    return () => dispatch(disableSwitcher());
  }, [markerData]);

  useEffect(() => {
    if (!isLabelPopupOpen) return;
    const availableLabels = sessionStorage?.getItem("AvailableLabelsPvt");
    const parsedLabels = JSON?.parse(availableLabels) || [];
    setLabels(parsedLabels);
  }, [isLabelPopupOpen]);

  useEffect(() => {
    getPrivateTxnData();
  }, [
    currentPage,
    pageSize,
    currentFileStatus,
    startDateFilter,
    endDateFilter,
    currentIfscCode,
    currentCategory,
    txnAmountFilter,
    phantomMarker,
    LabelSearchText,
  ]);

  const handlePagination = (page) => setCurrentPage(page);

  const handleSelect = (value) => {
    setPageSize(value);
    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const displayDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / GlobalConfiguration?.delayTime,
    );

    return timestamp;
  };

  const handleFilterDateRange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(displayDate(start));
      setEndDateFilter(displayDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  function capitalizeText(str) {
    if (!str) return str;
    const lower = str.split("_").join(" ").toLowerCase();
    const firstChar = lower
      .charAt(GlobalConfiguration?.lengthCheckZero)
      .toUpperCase();
    return firstChar + lower.slice(GlobalConfiguration?.lengthCheckOne);
  }

  useEffect(() => {
    const fetchData = async () => {
      let response;
      let data = [];

      try {
        switch (active) {
          case "IFSC code":
            response = await dispatch(
              getOwnerAccountIFSCDetails({
                search_string: searchUserTextDebounce,
                page_no: GlobalConfiguration?.lengthCheckOne,
                page_size: GlobalConfiguration?.filterResults,
              }),
            );

            data =
              response.payload.ifsc_details?.map((item) => ({
                id: item?.ifsc,
                IFSC_code: item?.ifsc,
              })) || [];

            break;

          case "Category":
            response = await dispatch(
              beneCategories({ search_string: searchUserTextDebounce }),
            );
            data =
              response?.payload?.categories?.map((item) => ({
                id: item?.name,
                Category_name: item?.name,
              })) || [];
            break;
          case "Labels":
            data = labels
              ?.filter((itm) => {
                if (itm.includes(searchUserTextDebounce)) return itm;
              })
              ?.map((val) => {
                return { id: val, Label: val };
              });
            setInputData(data);
            break;

          default:
            data = [];
            break;
        }
      } catch (error) {
        data = [];
      } finally {
        setInputData(data);
        // setLoadingData(false);
      }
    };
    fetchData();
  }, [active]);

  //Refresh Owner Account Balance
  const handleRefreshBalance = async (id) => {
    if (!id) return;

    try {
      toast.dismiss();

      CommonToast({
        text: "Refreshing balance",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });

      const response = await dispatch(getOwnerAccBalance(id));

      if (response?.payload?.status === true) {
        const newBalance =
          response?.payload?.owner_accounts[
            GlobalConfiguration?.lengthCheckZero
          ]?.owner_account_balance;
        const updatedTime =
          response?.payload?.owner_accounts[
            GlobalConfiguration?.lengthCheckZero
          ]?.owner_account_balance_last_fetched_at_in_words;

        setPrivateTxnData((prevData) => ({
          ...prevData,
          transaction_requests: prevData.transaction_requests.map((txn) => {
            if (txn?.owner_account_details?.owner_account_id === id) {
              return {
                ...txn,
                owner_account_details: {
                  ...txn.owner_account_details,
                  owner_account_balance: newBalance,
                  owner_account_balance_last_fetched_at_in_words: updatedTime,
                },
              };
            }
            return txn;
          }),
        }));
        toast.dismiss();
        CommonToast({
          text: "Balance updated",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        toast.dismiss();

        CommonToast({
          text:
            response?.payload?.response?.data?.errors?.base[
              GlobalConfiguration?.lengthCheckZero
            ] || "Update failed",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (error) {
      return error;
    }
  };

  const handleLabelPopupClose = () => {
    setIsLabelPopupOpen(false);
    setPhantomMarker((x) => x + GlobalConfiguration?.lengthCheckOne);
  };

  const [openAuthenticationPopup, setOpenAuthenticationPopup] = useState(false);

  const { otpValidationLoading, otpValidationError, otpValidationData } =
    useSelector((state) => state.privatetransactions);

  const [popUpData, setPopUpData] = useState({
    private_transaction_id: "",
    request_reference_id: "",
  });

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };
  const handleAssignLabelsProp = async (labelsToAssign) => {
    setAllPrivateTxnDataLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelId);
    console.log(recordIds, labelsToAssign, "recordIds, labelsToAssign");

    const res = await dispatch(
      addNewLabelPvt({ record_ids: recordIds, labels: labelsToAssign }),
    );
    if (addNewLabelPvt.fulfilled.match(res)) {
      await getPrivateTxnData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addNewLabelPvt.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setAllPrivateTxnDataLoading(false);
    if (addNewLabelPvt?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setAllPrivateTxnDataLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelId);
    const res = await dispatch(
      removeNewLabelPvt({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeNewLabelPvt.fulfilled.match(res)) {
      await getPrivateTxnData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeNewLabelPvt.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
    }
    setAllPrivateTxnDataLoading(false);
    if (removeNewLabelPvt?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <>
      {moreDetailOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <PrivateDetailPopup
            closePrivateDetailModal={() => {
              setMoreDetailOpen(false);
            }}
            private_id={moreDetailId}
            type={"private_detail_modal"}
            setPrivateTxnData={setPrivateTxnData}
          />
        </div>
      )}
      {openAuthenticationPopup && (
        <AuthenticationPopup
          setOpenAuthenticationPopup={setOpenAuthenticationPopup}
          openAuthenticationPopup={openAuthenticationPopup}
          otpValidationLoading={otpValidationLoading}
          otpValidationError={otpValidationError}
          otpValidationData={otpValidationData}
          delay={delay}
          id={popUpData?.private_transaction_id}
          ref_id={popUpData?.request_reference_id}
          currentOtpCount={selectedOtpCount}
          setPrivateTxnData={setPrivateTxnData}
          setSelectedOtpCount={setSelectedOtpCount}
          isPopup={false}
        />
      )}
      {isLabelPopupOpen && (
        <div
          onClick={handleLabelPopupClose}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex"
          max-zindex
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleLabelPopupClose}
            closeisDisabled={false}
            labels={popupLabels}
            setLabels={setLabels}
            LabelAccounts={labelId}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={(privateTxnData?.transaction_requests || [])
              .filter((acc) => {
                const currentId = acc?.request_reference_id;

                return Array.isArray(labelId)
                  ? labelId.includes(currentId)
                  : labelId === currentId;
              })
              .map((acc) => ({
                ...acc,
                id: acc?.request_reference_id,
              }))}
            onClose={handleLabelPopupClose}
            loading={allPrivateTxnDataLoading}
            setLoading={setAllPrivateTxnDataLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      {/* Pagination component */}

      {/* --------------------------- */}
      <div
        className={`flex flex-col items-center relative w-width-full h-full-height overflow-hidden`}
      >
        <div
          className={`bene_div_container Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act ${typepop === "popup" ? " w-full Qmd:w-full-popup-width" : "w-full-width"} relative `}
        >
          <div className="Qmd:min-h-navbar-breadcrumb-height bg-primary-nav"></div>
          <TopNavComponent
            topNavCtaBtn1Needed={false}
            handleBack={
              typepop === "popup"
                ? undefined
                : () => {
                    navigate(-1);
                  }
            }
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: allPrivateTxnDataLoading,
              onSearchInput: (val) => handleSearch(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search private transactions",
              filterPlaceholder: "transaction details",
              filterItems: [
                // {
                //   name: "IFSC code",
                //   short_name: "IFSC",
                //   valueType: "string",
                //   isMulti: false,
                //   value: currentIfscCode,
                //   setValue: setCurrentIfscCode,
                //   isDropdown: true,
                //   isDisabled: allPrivateTxnDataLoading ? true : false,
                // },
                {
                  name: "Category",
                  short_name: "Cat",
                  valueType: "string",
                  isMulti: false,
                  value: currentCategory,
                  setValue: setCurrentCategory,
                  isDropdown: true,
                  isDisabled: allPrivateTxnDataLoading ? true : false,
                },
                // {
                //   name: "Amount",
                //   short_name: "INR",
                //   valueType: "number",
                //   isMulti: false,
                //   value: txnAmountFilter,
                //   setValue: setTxnAmountFilter,
                //   displayValue: FormatAmount({ price: txnAmountFilter }),
                //   isDropdown: false,
                //   isDisabled: allPrivateTxnDataLoading ? true : false,
                // },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: setLabelSearchText,
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: allPrivateTxnDataLoading,
                },
              ],
              filters: [
                {
                  name: "File statuses",
                  filterType: "dropdown",
                  variant: "single",
                  isSearch: false,
                  searchPlaceholder: "Search",
                  isDisabled: true,
                  value: "Require Approval",
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(startDateFilter * GlobalConfiguration?.delayTime)
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(endDateFilter * GlobalConfiguration?.delayTime)
                    : endDateFilter,
                  handleChange: (date) => handleFilterDateRange(date),
                },
              ],

              inputData: inputData,
              active: active,
              setActive: setActive,

              isShowSortBy: false,
              isShowFilter: false,
            }}
          />
        </div>
        <div
          className={`flex flex-col items-center w-width-full h-height-full bg-primary-bg   mb-[var(--pagination-height)] ${
            showInnerSearchBar
              ? "overflow-y-hidden  cursor-pointer-none pointer-events-none"
              : "overflow-auto"
          }`}
        >
          {allPrivateTxnDataLoading ? (
            <div
              className={`m-auto justify-center items-center flex ${
                showInnerSearchBar
                  ? "overflow-y-hidden cursor-pointer-none pointer-events-none"
                  : ""
              }`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}
              <Loader />
            </div>
          ) : privateTxnData?.transaction_requests &&
            privateTxnData?.transaction_requests.length >
              GlobalConfiguration?.lengthCheckZero &&
            !allPrivateTxnDataLoading ? (
            <div
              className={`scroll flex flex-col  w-width-full items-center justify-center`}
              ref={filterRef}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}
              <div className="fixed w-full bottom-bottom-base bg-primary-nav z-z-index-tooltip">
                <div>
                  {showInnerSearchBar && (
                    <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
                  )}
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={pageSize}
                    data={privateTxnData}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              </div>
              <div className="scroll flex flex-col items-center justify-center w-width-full lg:w-auto px-padding-md lg:px-padding-base pb-padding-xl gap-gap-md">
                {privateTxnData?.transaction_requests.map((txn, index) => {
                  return (
                    <div
                      key={txn?.private_transaction_id}
                      className={`w-width-full ${index === GlobalConfiguration?.lengthCheckZero ? "mt-margin-md" : ""}`}
                    >
                      <CommonAccountApprovalCard
                        entries={[
                          [
                            {
                              type: "textSubtext",
                              text:
                                "INR " +
                                FormatAmount({
                                  price: txn?.total_amount,
                                }),
                              textColor: "settled",
                              subText: "Total transaction amount",
                              isBold: true,
                            },
                            {
                              type: "accountNumber",
                              text: txn?.owner_account_details
                                ?.owner_account_bank_acc_no,
                              subText: "Source account",
                              ifsc: txn?.owner_account_details
                                ?.owner_account_ifsc_code,
                            },
                            {
                              type: "amount",
                              text:
                                txn?.owner_account_details
                                  ?.owner_account_balance || 0,
                              subText: txn?.owner_account_details
                                ?.owner_account_balance_last_fetched_at_in_words
                                ? `Balance - updated ${txn?.owner_account_details?.owner_account_balance_last_fetched_at_in_words}`
                                : "Balance",
                              refreshOnClick: () =>
                                handleRefreshBalance(
                                  txn?.owner_account_details?.owner_account_id,
                                ),
                              shouldShowRefreshButton: checkService,
                            },
                          ],
                          [
                            {
                              type: "textSubtextX2",
                              text: txn?.category,
                              subText: "Category selected",

                              text1: txn?.created_at
                                ? formatDateViewAll(txn?.created_at, true, true)
                                : "N/A",

                              subText1: "Created on",
                            },
                            {
                              type: "textSubtext",
                              text: txn?.total_beneficiary_account_count,
                              subText: "Total beneficiary accounts",
                            },
                            {
                              type: "cta",
                              text:
                                txn?.labels?.join(", ") || "No labels assigned",
                              subText: "Labels",
                              onClick: (e) => {
                                setLabelId(txn?.request_reference_id);
                                setIsLabelPopupOpen(true);
                              },
                            },
                          ],
                          [
                            {
                              type: "textSubtext",
                              text: capitalizeText("Require approval"),
                              subText: "File status",
                              textColor: "var(--pending)",
                            },
                          ],
                        ]}
                        cardState={
                          txn?.request_status === "pending_for_otp" ||
                          txn?.request_status === "otp_submitted" ||
                          txn?.request_status === "otp_requested"
                            ? "single"
                            : "double"
                        }
                        overlay1Text={
                          txn?.request_status === "pending_for_otp" ||
                          txn?.request_status === "otp_submitted" ||
                          txn?.request_status === "otp_requested"
                            ? "Require authentication"
                            : "Blocked"
                        }
                        overlay1Subtext={
                          txn?.request_status === "pending_for_otp" ||
                          txn?.request_status === "otp_submitted" ||
                          txn?.request_status === "otp_requested" ? (
                            <>
                              <p> This transaction has been approved,</p>
                              <p> authenticate to create a transaction.</p>
                            </>
                          ) : (
                            ""
                          )
                        }
                        overlay1Icon={
                          txn?.request_status === "pending_for_otp" ||
                          txn?.request_status === "otp_submitted" ||
                          txn?.request_status === "otp_requested"
                            ? PendingIcons
                            : DeclinedRed
                        }
                        overlay1IconColor={
                          txn?.request_status === "pending_for_otp" ||
                          txn?.request_status === "otp_submitted" ||
                          txn?.request_status === "otp_requested"
                            ? "var(--pending)"
                            : ""
                        }
                        overlay1Cta2Disabled={""}
                        overlay1Cta2Color="var(--positive-act)"
                        overlay1Cta2Text={
                          txn?.request_status === "pending_for_otp" ||
                          txn?.request_status === "otp_submitted" ||
                          txn?.request_status === "otp_requested"
                            ? "Authenticate with OTP"
                            : ""
                        }
                        overlay1Cta2HoverType={"black"}
                        overlay1Cta2OnClick={() => {
                          setSelectedOtpCount(txn?.otp_attempts_count);
                          setPopUpData({
                            private_transaction_id: txn?.private_transaction_id,
                            request_reference_id: txn?.request_reference_id,
                          });
                          setOpenAuthenticationPopup(true);
                        }}
                        overlay1CtaText={"View details"}
                        overlay1CtaOnClick={() => {
                          setMoreDetailId(txn?.request_reference_id);
                          setMoreDetailOpen(true);
                        }}
                        overlay2Text={
                          txn?.request_status === "blocked"
                            ? "This transaction has been blocked permanently due to multiple failed OTP authentication attempts."
                            : ""
                        }
                        overlay2Subtext={
                          txn?.request_status === "blocked"
                            ? "Blocked reason"
                            : ""
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div
              className={`flex flex-col items-center justify-center m-auto  Qsmd:mt-[unset] mt-margin-md h-screen ${
                showInnerSearchBar
                  ? "overflow-y-hidden cursor-pointer-none pointer-events-none"
                  : ""
              }`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}
              {currentCategory ||
              LabelSearchText?.length !==
                GlobalConfiguration?.lengthCheckZero ? (
                <div className="flex flex-col gap-gap-md items-center justify-center">
                  <img
                    src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                    alt="No accounts found"
                    className="w-graphic-width-lg h-graphic-square-height-md"
                  />
                  <p className="text-text-primary text-font-sm font-normal">
                    No data found.
                  </p>
                  <div>
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={handleClearParams}
                      enabledTextColor="var(--text-primary)"
                    />
                  </div>
                </div>
              ) : (
                <div className="flex flex-col gap-gap-md items-center justify-center">
                  <img
                    src="https://q2pay.in/new_assets/graphics/no_data/no_pending_transaction.svg"
                    alt="No accounts found"
                    className="w-graphic-width-lg h-graphic-square-height-md"
                  />
                  <p className="text-text-primary text-font-sm font-normal">
                    There are no more transactions that require your approval.
                  </p>
                  <div>
                    <PrimaryButton
                      btnText="Private transaction dashboard"
                      handleFunction={() =>
                        navigate("/private_transaction_dashboard")
                      }
                      btnType="button"
                      isDisabled={false}
                      enabledTextColor="var(--text-primary)"
                      disabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      hoverOption="white"
                      fullWidthRequired={false}
                      inActiveVariantNeeded={false}
                      isLoaderNeeded={false}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PrivateTxnAuthentication;
